import PropTypes from "prop-types";

const WhyUsCard = ({title, image, description}) => {
  return (
    <div className="why__item">
      <img className="why__icon" src={`/images/${image}`} width="214" alt=""/>
      <div className="why_item-container">
        <h3 className="why__item-title">{title}</h3>
        <p className="why__item-description">{description}</p>
      </div>
    </div>
  );
};

WhyUsCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default WhyUsCard;
